import { DrawingItem } from "src/js/types/DrawingItem";
import { drawingStore } from "../store";

export const setSelectedGeometry = (id: DrawingItem["id"]) => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  store.dispatch(actions.setSelectedState(id));
};
